import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  DETAIL_LOGIN_HERE,
  FIRST_TIME_BUYER,
} from '../../../brands/default/content/components/checkout';
import { setUserEmail } from '../../../redux/actions/email';
import { panel } from './UserPanelSetup';

const UserRegistrationTitle = ({ setActivePanel }) => {
  const dispatch = useDispatch();

  const linkAction = async (event) => {
    event.preventDefault();
    setActivePanel(panel.login);
    dispatch(setUserEmail(''));
  };

  return (
    <>
      <div className="row details-title align-items-center">
        <div className="col details-title__left-block text-nowrap">
          {FIRST_TIME_BUYER}
        </div>
        <div className="col text-right details-title__right-block">
          <Link href="#">
            <a
              onClick={linkAction}
              onKeyDown={linkAction}
              role="link"
              tabIndex={0}
            >
              {DETAIL_LOGIN_HERE}
            </a>
          </Link>
        </div>
      </div>
      <style jsx>{`
        .details-title__left-block {
          position: relative;
        }
      `}</style>
    </>
  );
};

UserRegistrationTitle.propTypes = {
  setActivePanel: PropTypes.func.isRequired,
};

export default UserRegistrationTitle;
